import OrganizationServer from "@/api/organization"

export default {

    namespaced: true,

    state: {
        currentRowId: null,
        visitedIds: [],

        pageSearch: {
            current: 1,
            size: 10,
            search: {
                status: true,
                like_name: null,
                like_description: null,
            },
        },
        page: {
            total: 0,
            records: []
        },
    },

    getters: {
        currentRowId(state) {
            return state.currentRowId;
        },
        visitedIds(state) {
            return state.visitedIds;
        },
        pageSearch(state) {
            return state.pageSearch;
        },
        page(state) {
            return state.page;
        },
    },

    mutations: {
        setCurrentRowId(state, currentRowId) {
            state.currentRowId = currentRowId;
        },
        addVisitedId(state, currentRowId) {
            if (currentRowId != null) {
                let visitedIds = state.visitedIds;
                let existed = false;
                for (let i = 0, len = visitedIds.length; i < len; i++) {
                    if (visitedIds[i] === currentRowId) {
                        existed = true;
                        break;
                    }
                }
                if (!existed) {
                    visitedIds.push(currentRowId);
                }
            }
        },
        removeVisitedId(state, currentRowId) {
            if (currentRowId != null) {
                let visitedIds = state.visitedIds;
                let index = -1;
                for (let i = 0, len = visitedIds.length; i < len; i++) {
                    if (visitedIds[i] === currentRowId) {
                        index = i;
                        break;
                    }
                }
                if (index > -1) {
                    visitedIds.splice(index, 1);
                }
            }
        },
        setPageSearch(state, pageSearch) {
            state.pageSearch = pageSearch;
        },
        setPageSearchCurrent(state, current) {
            state.pageSearch.current = current;
        },
        setPageSearchSize(state, size) {
            state.pageSearch.size = size;
        },
        setPageSearchSearch(state, search) {
            state.pageSearch.search = search;
        },
        setPage(state, page) {
            state.page = page;
        },
    },

    actions: {
        async doQueryByPage({commit}, pageSearch) {
            // 查询
            OrganizationServer.qualification.page(pageSearch).then(res => {
                if (res.data.code == null || res.data.code === '200') {
                    let records = res.data.data.records;
                    if (records.length === 0 && pageSearch.current > 1) {
                        commit('setPageSearchCurrent', pageSearch.current - 1);
                    } else {
                        commit('setPage', res.data.data);
                    }
                }
            });
        },
    },

}